import { render, staticRenderFns } from "./materialReport.vue?vue&type=template&id=d6751804&scoped=true"
import script from "./materialReport.vue?vue&type=script&lang=js"
export * from "./materialReport.vue?vue&type=script&lang=js"
import style0 from "./materialReport.vue?vue&type=style&index=0&id=d6751804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6751804",
  null
  
)

export default component.exports